import axios from 'axios';

// 배포 환경에서는 REACT_APP_API_URL을 사용, 로컬 개발에서는 동일 출처('/api')로 프록시
const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

// 게스트용 API 클라이언트
const guestApi = axios.create({
  baseURL: API_BASE_URL ? `${API_BASE_URL}` : '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 게스트용 API 타입 정의
export interface GuestPost {
  id: number;
  authorId: number;
  type: 'case_study' | 'research' | 'discussion' | 'job';
  title: string;
  content: string;
  tags: string[];
  images?: string[]; // Array of image URLs
  likes: number;
  views: number;
  createdAt: string;
  authorName: string;
  hospital?: string;
  specialization?: string;
  isVerifiedDoctor: boolean;
  licenseVerified?: boolean; // 면허 등록 여부
}

// 게스트용 API
export const guestAPI = {
  // 게시글 목록 조회 (읽기 전용)
  getPosts: (params?: {
    type?: string;
    q?: string;
    tag?: string;
    page?: number;
    limit?: number;
  }) => guestApi.get('/guest/posts', { params }),

  // 게시글 상세 조회 (읽기 전용)
  getPost: (id: number) => guestApi.get(`/guest/posts/${id}`),

  // AI 상담 (제한된 기능)
  consult: (query: string) => guestApi.post('/guest/ai/consult', { query }),
};

export default guestApi;




